import styles from './index.module.css'

export const Formula = () => {
  return (
    <div className={styles.image_container}>
      <img src="/assets/Formula%20(1).png" alt="" />
    </div>
  )
}

